import { Route } from "react-router";
import { MainContentLayout } from "src/components/Layout/MainContentLayout";
import AccessDeniedPage from "./AccessDeniedPage";

export const useCMSRouter = () => {
    return (
        <>
            <Route path="access-denied" element={<MainContentLayout />}>
                <Route index element={<AccessDeniedPage />} />
            </Route>

            {/** Blog route removed; generic catch-all in App.tsx handles CMS pages */}
        </>
    );
};
